/** @format */

import React, { useEffect, useState } from "react";
import AddUpdateApproveVendor from "../Pages/AddUpdateApproveVendor";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@mui/material";
import VendorProfileView from "./VendorProfileView";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const VendorProfile = () => {
  const [vendorData, setVendorData] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const { vendorId } = useParams();
  async function getvendorDetailsById() {
    setIsFetching(true);
    try {
      const vendorResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(vendorResponse);
      setVendorData(vendorResponse.data);
    } catch (err) {
      console.log(err);
    }
    setIsFetching(false);
  }
  useEffect(() => {
    getvendorDetailsById();
  }, []);
  return (
    <>
      {editMode ? (
        isFetching ? (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <AddUpdateApproveVendor vendorDetails={vendorData} />
        )
      ) : (
        <>
          {isFetching ? (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <>
              <Button
                variant="outlined"
                startIcon={<ModeEditIcon />}
                sx={{ my: 2 }}
                onClick={() => setEditMode(true)}>
                Edit
              </Button>
              <VendorProfileView vendorDetails={vendorData} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default VendorProfile;
